export const MOBILE = 'mobile';
export const TABLET = 'tablet';
export const DESKTOP = 'desktop';

export const MIN_TABLET_WIDTH = 768;
export const MIN_DESKTOP_WIDTH = 1024;
